import endpoints from "../../../Helpers/Endpoints";
import { apiGetRequest } from "../../../Helpers/Requests";

// A helper function to run all pre-checks before opening the job modal
const jobModalPreChecks = async (profileData, setOpenBankDetailsMissingModal) => {
  const testCases = [
    async () => {
      try {
        const response = await apiGetRequest(
          endpoints.hasSupplierBankDetails(profileData.id)
        );
        const data = response.data;

        if (data.has_bank_details === false) {
          setOpenBankDetailsMissingModal(true);
          throw new Error("Missing bank details");
        }
      } catch (error) {
        console.error("Error checking bank details:", error);
        throw error;
      }
    },

    // Add more checks here
  ];

  for (const testCase of testCases) {
    await testCase();
  }
};

export default jobModalPreChecks;
